import { useState, useEffect, useCallback } from "react";

const STORAGE_KEY = "mc_prose_scale";
const SCALES = ["sm", "base", "lg"];
const PROSE_CLASS = {
  sm: "prose-sm",
  base: "prose-base",
  lg: "prose-lg",
};
const FONT_SIZE = {
  sm: "14px",
  base: "16px",
  lg: "18px",
};
const CONTENT_ZOOM = {
  sm: 0.9,
  base: 1,
  lg: 1.25,
};

function readStoredScale() {
  try {
    const v = localStorage.getItem(STORAGE_KEY);
    if (SCALES.includes(v)) return v;
  } catch {
    // ignore
  }
  return "base";
}

export function useProseScale() {
  const [scale, setScaleState] = useState(() => readStoredScale());

  useEffect(() => {
    try {
      localStorage.setItem(STORAGE_KEY, scale);
    } catch {
      // ignore
    }
  }, [scale]);

  useEffect(() => {
    const root = document.querySelector(".theme-clinical");
    if (!root) return undefined;
    root.style.setProperty("--clinical-prose-scale", FONT_SIZE[scale] || FONT_SIZE.base);
    return () => {
      root.style.removeProperty("--clinical-prose-scale");
    };
  }, [scale]);

  const decrease = useCallback(() => {
    setScaleState((s) => {
      const i = SCALES.indexOf(s);
      return i > 0 ? SCALES[i - 1] : s;
    });
  }, []);

  const increase = useCallback(() => {
    setScaleState((s) => {
      const i = SCALES.indexOf(s);
      return i < SCALES.length - 1 ? SCALES[i + 1] : s;
    });
  }, []);

  const proseClassName = PROSE_CLASS[scale] || PROSE_CLASS.base;

  return {
    scale,
    decrease,
    increase,
    canDecrease: scale !== "sm",
    canIncrease: scale !== "lg",
    proseClassName,
    contentZoom: CONTENT_ZOOM[scale] || CONTENT_ZOOM.base,
  };
}
